import styled from "styled-components";

import Grid from "../containers/Grid";

const FieldGrid = styled(Grid)`
  select {
    width: 100%;
  }
`;

export default FieldGrid;
